module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#bs-example-navbar-collapse-1",
      "aria-expanded": "false"
    },
    on: {
      "click": _vm.toggleCollapse
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])]), _vm._v(" "), _c('div', {
    class: ['navbar-collapse', {
      collapse: _vm.data.collapsed
    }],
    attrs: {
      "id": "bs-example-navbar-collapse-1"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [(_vm.config.hasPerm('add_channel') || _vm.config.hasPerm('add_area') || _vm.config.hasPerm('add_company') || _vm.config.hasPerm('add_datenotavailable') || _vm.config.hasPerm('add_user') || _vm.config.hasPerm('add_reason') || _vm.config.hasPerm('add_subreason') || _vm.config.hasPerm('add_unit')) ? _c('li', {
    staticClass: "dropdown",
    class: _vm.data.adminDisplay
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:void(0);",
      "data-toggle": "dropdown"
    },
    on: {
      "click": function($event) {
        _vm.toggleOptionsAdmin()
      }
    }
  }, [_vm._v("Administración "), _c('span', {
    staticClass: "caret",
    attrs: {
      "id": "menu-admin"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/User"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Usuarios")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Unit"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Unidades")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Area"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Áreas")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Reason"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Motivos")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Subreason"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Sub motivos")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Channel"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Canales")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Company"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Empresa o filial")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/DateNotAvailable"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Días no hábiles")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Export"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Exporte")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Genero"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Géneros")])], 1)])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "dropdown",
    class: _vm.data.pqrDisplay
  }, [_c('a', {
    staticClass: "dropdown-toggle active",
    attrs: {
      "href": "javascript:void(0);",
      "data-toggle": "dropdown"
    },
    on: {
      "click": function($event) {
        _vm.toggleOptionsPQR()
      }
    }
  }, [_vm._v("PQR "), _c('span', {
    staticClass: "caret",
    attrs: {
      "id": "menu-pqr"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.config.hasPerm('add_pqr')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/RegisterPqr"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Registrar")])], 1) : _vm._e(), _vm._v(" "), (_vm.config.hasPerm('can_list_pqr') && _vm.config.hasPerm('can_retrieve_pqr') && _vm.config.hasPerm('change_pqr')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/ConsultPqr"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Consultar")])], 1) : (_vm.config.hasPerm('can_list_pqr')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/ConsultPqr"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideOptions()
      }
    }
  }, [_vm._v("Consultar")])], 1) : _vm._e()])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('p', {
    staticClass: "date_bar"
  }, [_vm._v("Bienvenido: " + _vm._s(this.user) + " Fecha: " + _vm._s(this.date) + " ")])]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    },
    nativeOn: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Cerrar Sesión")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa77c8a0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/emt-menu-bar.vue
// module id = 77
// module chunks = 0